import './App.css'

import { useEffect } from 'react'
import axios from 'axios'
import {
  Navigate,
  Route,
  Routes,
  useLocation
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import AdminLogin from './Components/Admin/AdminLogin'
import AdminDashboard from './Components/Admin/AdminDashboard'
import Disbursements from './Components/Admin/Disbursements'
import LoanApplications from './Components/Admin/LoanApplications'
import LoanReviews from './Components/Admin/LoanReviews'
import OverdueLoans from './Components/Admin/OverdueLoans'
import Tenants from './Components/Admin/Tenants'
import TransactionHistory from './Components/Admin/TransactionHistory'
import PhysicalVerification from './Components/Admin/PhysicalVerification'
import { actions } from './store'

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('access_token')
  return token ? children : <Navigate to="/" replace />
}

function App() {
  const dispatch = useDispatch()
  const { url } = useSelector(state => state)
  const location = useLocation()

  useEffect(() => {
    const token = localStorage.getItem('access_token')

    if (!token || location.pathname === '/') {
      return
    }

    const headers = {
      Authorization: `Bearer ${token}`
    }

    const getLoanApplications = async () => {
      try {
        const response = await axios.get(
          `${url}/admin/get-loan-applications`,
          { headers }
        )

        dispatch(actions.updateLoanApplications(response.data || []))
      } catch (error) {
        console.error('Failed to fetch loan applications:', error)
      }
    }

    const getTransactionHistory = async () => {
      try {
        const response = await axios.get(
          `${url}/admin/fetch-payments`,
          { headers }
        )

        dispatch(actions.updateTransactions(response.data || []))
      } catch (error) {
        console.error('Failed to fetch transaction history:', error)
      }
    }

    const getTenants = async () => {
      try {
        const response = await axios.get(
          `${url}/admin/fetch-tenants`,
          { headers }
        )

        dispatch(actions.updateTenants(response.data || []))
      } catch (error) {
        console.error('Failed to fetch tenants:', error)
      }
    }

    const getLoanReviews = async () => {
      try {
        const response = await axios.get(
          `${url}/admin/loan-applications/review`,
          { headers }
        )

        dispatch(
          actions.updateLoanReviews(
            response.data.applications || []
          )
        )
      } catch (error) {
        console.error('Failed to fetch loan reviews:', error)
      }
    }

    getLoanApplications()
    getTransactionHistory()
    getTenants()
    getLoanReviews()
  }, [url, dispatch, location.pathname])

  const protect = element => (
    <ProtectedRoute>
      {element}
    </ProtectedRoute>
  )

  return (
    <Routes>
      <Route path="/" element={<AdminLogin />} />
      <Route path="/dashboard" element={protect(<AdminDashboard />)} />
      <Route path="/loan_applications" element={protect(<LoanApplications />)} />
      <Route path="/tenants" element={protect(<Tenants />)} />
      <Route path="/disbursements" element={protect(<Disbursements />)} />
      <Route path="/transaction_history" element={protect(<TransactionHistory />)} />
      <Route path="/loan_reviews" element={protect(<LoanReviews />)} />
      <Route path="/overdue_loans" element={protect(<OverdueLoans />)} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
      <Route
  path="/physical-verification"
  element={<PhysicalVerification />}
/>
    </Routes>
  )
}

export default App
